module.exports = global["jQuery"] = require("-!F:\\qsujuan\\wwwroottwo\\s山东港口集团\\sdgangkou\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");